import { createContext } from 'react';

type MatchRateContextType = {
  generatedAt?: string;
  setGeneratedAt: (date: string) => void;
  totalRecords?: number;
  setTotalRecords: (records: number) => void;
  onRefresh?: () => void;
  setOnRefresh: (onRefresh: () => void) => void;
};

const MatchRateContext = createContext<MatchRateContextType>({
  totalRecords: undefined,
  setTotalRecords: (_records: number) => {},
  generatedAt: undefined,
  setGeneratedAt: (_date: string) => {},
  onRefresh: undefined,
  setOnRefresh: (_onRefresh: () => void) => {},
});

export { MatchRateContext };
